module.exports = __webpack_public_path__ + "img/47.e2841bc0.e2841bc0.svg";